import { render, staticRenderFns } from "./AamsRegSealUsageRecordDetail.vue?vue&type=template&id=319b33c2&scoped=true&"
import script from "./AamsRegSealUsageRecordDetail.vue?vue&type=script&lang=js&"
export * from "./AamsRegSealUsageRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./AamsRegSealUsageRecordDetail.vue?vue&type=style&index=0&id=319b33c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b33c2",
  null
  
)

export default component.exports